import { useMemo, useState } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { saveContentFeedback } from '../lib/intelligence'

type Props = {
  targetKey: string
  targetLabel: string
}

export function ResolutionFeedback({ targetKey, targetLabel }: Props) {
  const { profile, offlineProfile } = useAuth()
  const storageKey = useMemo(() => `suite:resolution:${targetKey}`, [targetKey])
  const [answered, setAnswered] = useState(() => {
    try { return sessionStorage.getItem(storageKey) === '1' } catch { return false }
  })
  const [sending, setSending] = useState(false)

  async function answer(resolved: boolean) {
    if (!profile?.ativo || offlineProfile || sending) return
    setSending(true)
    try {
      await saveContentFeedback(profile.id, targetKey, targetLabel, resolved)
      try { sessionStorage.setItem(storageKey, '1') } catch { /* mantém apenas estado em memória */ }
      setAnswered(true)
    } finally {
      setSending(false)
    }
  }

  if (!profile?.ativo || offlineProfile || answered) return null

  return (
    <aside className="resolution-feedback" aria-label="Feedback sobre a orientação">
      <div>
        <strong>Esta ferramenta ou orientação ajudou a resolver sua necessidade?</strong>
        <small>Resposta rápida e opcional. Usamos apenas para melhorar o conteúdo do Suite.</small>
      </div>
      <div className="resolution-feedback__actions">
        <button type="button" disabled={sending} onClick={() => void answer(true)}>Sim</button>
        <button type="button" disabled={sending} onClick={() => void answer(false)}>Não</button>
      </div>
    </aside>
  )
}
